import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Avatar,
  Card,
  Col,
  Container,
  Content,
  DOMHelper,
  Heading,
  Panel,
  Placeholder,
  Row,
  Stack
} from 'rsuite';
import PageContent from '@/components/PageContent';
import { getCurrentUser, getRefreshToken, getToken } from '@/services/auth.service';
import moment from 'moment';
import './styles.less';
import {
  FaBuilding,
  FaChartArea,
  FaHome,
  FaLightbulb,
  FaRegBuilding,
  FaRocket,
  FaSuitcase,
  FaUserAlt,
  FaUsersCog,
  FaUserTie
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import Header from '@/components/Header';
import { Icon } from '@rsuite/icons';
import { RiCalendarCloseLine, RiHomeOfficeFill, RiOrganizationChart } from 'react-icons/ri';
import { TbBuildingCommunity } from 'react-icons/tb';
import { IoIosStats } from 'react-icons/io';
import { GrMapLocation } from 'react-icons/gr';
import Joyride from 'react-joyride';
import { useAppSelector } from '@/config/hooks';
import { AiFillHome } from 'react-icons/ai';
import { GiOrganigram } from 'react-icons/gi';
import { FaCalendarXmark, FaMapLocationDot, FaUsersGear } from 'react-icons/fa6';
import { IoPieChart } from 'react-icons/io5';
import { PiOfficeChairFill } from 'react-icons/pi';
// import WaveCard from './WaveCard';
// import CardComponent from './WaveCard';
// import CardGrid from './CardGrid';
import './Card.css';

const hexToRgb = hex => {
  let r, g, b;
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }
  return `${r}, ${g}, ${b}`;
};

const Page = ({ features, setSelectedFeature }) => {
  const navigate = useNavigate();

  const loading = useAppSelector(state => state.feature.loading);

  const [modules, setModules] = useState([]);
  // const [run, setRun] = useState(true);
  const [time, setTime] = useState(new Date());
  const { getHeight } = DOMHelper;

  const currentUser = getCurrentUser();

  // const steps = [
  //   {
  //     target: '#modules-cards',
  //     content: 'Select the desired module to continue.',
  //     placement: 'bottom'
  //   }
  // ];

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {

    const featuresArray: any = [
      {
        value: 'organizationSettings',
        label: t('Organization'),
        name: 'Organization',
        icon: <FaUsersGear className="card-icon" color="#53a4d4" size={30} />,

        // icon: (
        //   <FaUsersCog
        //     // className="card-icon"
        //     color="#1e9da0"
        //     style={{ fontSize: 70 }}
        //   />
        // ),
        color: '#53a4d4',
        description: t("Manage your organization's structure and members efficiently")
      }
    ];

    const addedFeatures = new Set();

    features?.forEach(project => {
      const featureName = project.name?.toLowerCase();

      if (featureName === 'on site') {
        if (!addedFeatures.has('flexOffice')) {
          featuresArray.push({
            label: t('Flex Office'),
            value: 'flexOffice',
            icon: <PiOfficeChairFill className="card-icon" color="#205dbd" size={30} />,
            color: '#205dbd',
            description: t('Optimize workspace usage with a flexible desk-sharing system')
          });
          addedFeatures.add('flexOffice');
        }
      }

      if (featureName === 'wfh') {
        if (!addedFeatures.has('remoteWork')) {
          featuresArray.push({
            label: t('Remote Work'),
            value: 'remoteWork',
            icon: <RiHomeOfficeFill className="card-icon" color="#56c7f0" size={30} />,
            color: '#56c7f0',
            description: t('Streamline remote work management and approvals')
          });
          addedFeatures.add('remoteWork');
        }
      }

      if (featureName === 'leave') {
        if (!addedFeatures.has('Leave')) {
          featuresArray.push({
            label: t('Leave'),
            value: 'leave',
            icon: <FaCalendarXmark className="card-icon" color="#1976d2" size={30} />,
            color: '#1976d2',
            description: t('Simplify leave requests and tracking for employees')
          });

          addedFeatures.add('Leave');
        }
      }

      if (featureName === 'travel') {
        if (!addedFeatures.has('travel')) {
          featuresArray.push({
            label: t('Business Travel'),
            value: 'travel',
            icon: <FaMapLocationDot className="card-icon" color="#00acc1" size={30} />,
            color: '#00acc1',
            description: t('Plan, manage, and track business trips seamlessly')
          });
          addedFeatures.add('travel');
        }
      }
    });

    if (!addedFeatures.has('analytics')) {
      featuresArray.push({
        label: t('Analytics'),
        value: 'analytics',
        icon: <FaChartArea className="card-icon" color="#3b82f6" size={30} />,
        color: '#3b82f6',
        description: t('Gain valuable insights with real-time data and reports')
      });
      addedFeatures.add('analytics');
    }

    setModules(featuresArray);
  }, [features]);

  const handleFeatureChange = feature => {
    if (feature == 'travel') {
      window.location.href = `${
        process.env.REACT_APP_FLEX_URL
      }admin?token=${getToken()}&refreshToken=${getRefreshToken()}`;
      return;
    }

    const featureObject: any = modules.find((item: any) => item.value == feature);
    setSelectedFeature(featureObject);
    localStorage.setItem('module', JSON.stringify(featureObject));
  };

  const CircularCard2 = ({ value, icon, title, color }) => (
    <div
      className={`circular-card `}
      style={{ backgroundColor: '#eeeff7' }}
      onClick={async () => {
        await handleFeatureChange(value);
        navigate('/home');
      }}
    >
      {icon}
      <p style={{ color: color }}>{title}</p>
    </div>
  );

  const CircularCard = ({ value, icon, title, color }) => (
    <div
      className={`circular-card `}
      // style={{ backgroundColor: `rgba(${hexToRgb(color)}, 0.1)` }}
      style={{
        background: 'linear-gradient(to bottom, rgb(221, 231, 241), rgb(234, 242, 250))'
      }}
      // style={{ backgroundColor: 'rgb(221, 231, 241)' }}
      onClick={() => {
        handleFeatureChange(value);
        navigate('/home');
      }}
    >
      {icon}
      <p style={{ paddingTop: 10, fontSize: 18 }}>{title}</p>
    </div>
  );
  const { t } = useTranslation();
  return (
    <Container className="frame" style={{ backgroundColor: '#f0f4f8' }}>
      {/* <Container className={containerClasses}>
        <Header showFeatures={false} />
      </Container> */}
      <PageContent
        style={{ background: 'none', overflow: 'auto', height: '100vh' }}
        className="board-wrapper "
        showCopyright={false}
      >
        <Header showFeatures={false} />
        <Stack
          justifyContent="center"
          // className="header "
          alignItems="center"
          style={{ marginTop: '7%' }}
        >
          <Heading level={4}>{t('Welcome to WorkPoint administration console')}</Heading>
        </Stack>

        {/* <div className="card-container">
          <div className="circle-outer">
            <div className="circle-inner">01</div>
          </div>
          <Panel shaded className="card-content">
            <div className="icon">
              <img src="/path/to/icon.png" alt="Icon" />
            </div>
            <h4>Lorem Ipsum</h4>
            <p>
              Lorem ipsum dolor sit amet, do eiusmod tempor incididunt aliqua. Utenimadmrnim veniam
            </p>
          </Panel>
        </div> */}

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '50px',
            marginTop: '120px',
            flexWrap: 'wrap'
          }}
        >
          {modules
            ?.filter(module => currentUser?.moduleAccess?.includes(module.value))
            ?.map(item => (
              <CardInfographic
                key={item.value}
                value={item.value}
                icon={item.icon}
                title={item.label}
                color={item.color}
                description={item.description}
                handleFeatureChange={handleFeatureChange}
              />
            ))}
        </div>
        {/* <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '50px' }}>
          <WaveCard
            title="Consultation"
            icon={<FaUserTie className="icon" />}
            color="#a855f7"
            tags={['TESTING', 'ANALYZE']}
          />
          <WaveCard
            title="Develop"
            icon={<FaRocket />}
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
            color="#f97316"
          />
          <WaveCard title="Design" icon={<FaLightbulb />} color="#06b6d4" tags={['UI', 'UX']} />
        </div> */}

        {/* <div className="card-container">
          <CardComponent icon={<FaUserTie size={40} />} title="Consultation" color="#8A2BE2" />
          <CardComponent
            icon={<FaRocket size={40} />}
            title="Develop"
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
            color="#FF4500"
          />
          <CardComponent icon={<FaLightbulb size={40} />} title="Design" color="#00BFFF" />
        </div> */}
        {/* <CardGrid />

        <CardInfographic number={1} title="Croissance" text="Lorem ipsum" />
        <CardInfographic number={2} title="Finance" text="Leven gautier" />
        <CardInfographic number={3} title="Objectif" text="Lorem um" />
        <CardInfographic number={4} title="Lancement" text="Lorem ipsumur" /> */}
      </PageContent>
    </Container>
  );
};

export default Page;

const CardInfographic = ({ value, icon, title, color, description, handleFeatureChange }) => {
  const navigate = useNavigate();
  // let headerColor = '';
  // switch (number) {
  //   case 1:
  //     headerColor = '#ffd700'; // Jaune
  //     break;
  //   case 2:
  //     headerColor = '#ffa500'; // Orange
  //     break;
  //   case 3:
  //     headerColor = '#1e90ff'; // Bleu
  //     break;
  //   case 4:
  //     headerColor = '#20b2aa'; // Turquoise
  //     break;
  //   default:
  //     headerColor = '#ffd700';
  const lightenColor = (color, percent) => {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const r = (num >> 16) + amt;
    const g = ((num >> 8) & 0x00ff) + amt;
    const b = (num & 0x0000ff) + amt;

    return `rgb(${Math.min(r, 255)}, ${Math.min(g, 255)}, ${Math.min(b, 255)})`;
  };
  // }

  return (
    <div
      className="card-container"
      onClick={() => {
        handleFeatureChange(value);
        navigate('/home');
      }}
    >
      <div
        className="card-top-bg"
        style={{
          background: `linear-gradient(to right, ${color}, ${lightenColor(color, 10)})`
          // backgroundColor: color
        }}
      ></div>
      <div
        className="circle-outer"
        style={{
          // background: 'linear-gradient(to right, rgb(221, 231, 241), rgb(234, 242, 250))'
          backgroundColor: color
        }}
      >
        <div className="circle-inner">{icon}</div>
      </div>
      <div className="card-content">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};
